// removed by extract-text-webpack-plugin
module.exports = {"container":"src-styles----about-module---container---17zLm","title":"src-styles----about-module---title---1t-fY","description":"src-styles----about-module---description---4qvPd"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/about.module.css
// module id = 314
// module chunks = 263791100135453